import { TenantListResponseSchema } from "@l30/shared";
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "./client.js";

/**
 * Cross-tenant tenant registry hook. Returns the list of all tenants
 * the operator can act against — used to drive the cross-tenant
 * switcher on the portal-users page.
 *
 * Gated on the API to admin/exec via the `tenants` permission key.
 * Other staff roles get 403; the hook surfaces that as an error.
 */
const TENANTS_KEY = ["tenants"] as const;

export function useTenants(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: TENANTS_KEY,
    enabled: options.enabled ?? true,
    queryFn: () => apiFetch("/tenants", {}, TenantListResponseSchema),
    // Tenant list rarely changes during a session; aggressive cache
    // is fine. Re-fetch on window focus so newly-provisioned tenants
    // appear without a hard reload.
    staleTime: 5 * 60 * 1000,
  });
}
